import { lazy } from "react";

export const ShowECitizenDataTable = lazy(
  () => import("../../Features/ShowECitizenDataTable")
);
